"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Search } from "lucide-react";
import { CAPABILITY_PANEL } from "@/lib/utils/capabilityWeb.utils";
const QUERIES = ["your brand", "your studio", "your product", "your agency"];
const TITLE_W = ["33%", "27%", "42%", "30%"];
const HEAD_W = ["66%", "74%", "56%", "70%"];
const HEAD_H = [10, 13, 9, 11];
const LAST_W = ["80%", "68%", "90%", "74%"];
const CapabilitySeoSearch = () => {
  const $ = _c(26);
  const [i, setI] = useState(0);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const t = setInterval(() => setI(_temp), 2400);
      return () => clearInterval(t);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      duration: 0.55,
      ease: "easeInOut" as const
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const reshape = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Search size={13} className="shrink-0" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0,
      y: 6
    };
    t5 = {
      opacity: 1,
      y: 0
    };
    t6 = {
      opacity: 0,
      y: -6
    };
    t7 = {
      duration: 0.4
    };
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  const t8 = QUERIES[i];
  let t9;
  if ($[8] !== i || $[9] !== t8) {
    t9 = <div className="mb-3 flex items-center gap-2 rounded-lg bg-neutral-100 px-3 py-2 text-[11px] text-neutral-400">{t3}<span className="relative inline-block h-3 flex-1 overflow-hidden"><AnimatePresence mode="wait"><motion.span key={i} initial={t4} animate={t5} exit={t6} transition={t7} className="absolute inset-0">{t8}</motion.span></AnimatePresence></span></div>;
    $[8] = i;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = TITLE_W[i];
  let t11;
  if ($[11] !== t10) {
    t11 = <motion.span className="mb-1.5 block h-1.5 rounded bg-card-foreground/70" initial={false} animate={{
      width: t10
    }} transition={reshape} />;
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = HEAD_W[i];
  const t13 = HEAD_H[i];
  let t14;
  if ($[13] !== t12 || $[14] !== t13) {
    t14 = <motion.span className="mb-2 block rounded bg-neutral-700" initial={false} animate={{
      width: t12,
      height: t13
    }} transition={reshape} />;
    $[13] = t12;
    $[14] = t13;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="mb-1 block h-1.5 w-full rounded bg-neutral-200" />;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  const t16 = LAST_W[i];
  let t17;
  if ($[17] !== t16) {
    t17 = <motion.span className="block h-1.5 rounded bg-neutral-200" initial={false} animate={{
      width: t16
    }} transition={reshape} />;
    $[17] = t16;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== t11 || $[20] !== t14 || $[21] !== t17) {
    t18 = <div className="rounded-lg border border-card-foreground/20 bg-card-foreground/5 p-2.5">{t11}{t14}{t15}{t17}</div>;
    $[19] = t11;
    $[20] = t14;
    $[21] = t17;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== t18 || $[24] !== t9) {
    t19 = <div className={CAPABILITY_PANEL}>{t9}{t18}</div>;
    $[23] = t18;
    $[24] = t9;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  return t19;
};
export default CapabilitySeoSearch;
function _temp(v) {
  return (v + 1) % QUERIES.length;
}